import React from 'react';
import PropTypes from 'prop-types';

import APIClient from '@ts-core/networking/APIClient';

import { ApiClientContext } from './ApiClientContext';

const ApiClientProvider = ({ children, apiBaseUrl }) => {
  const apiClient = new APIClient({ baseUrl: apiBaseUrl });
  return (
    <ApiClientContext.Provider value={apiClient}>
      {children}
    </ApiClientContext.Provider>
  );
};

ApiClientProvider.propTypes = {
  children: PropTypes.node.isRequired,

  apiBaseUrl: PropTypes.string.isRequired,
};

export default ApiClientProvider;
